<template>
  <div>
    <PrimaryButton @click.native="openDialog" class="mb-5" full-width light>
      Add Qualification
    </PrimaryButton>
    <AddQualificationDialog v-if="isOpen" @close="closeDialog" />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AddQualificationDialog from "@/views/profile/QuestionsAndAnswers/steps/Qualifications/dialogs/AddQualificationDialog";

export default {
  name: "AddQualificationAction",
  components: {
    PrimaryButton,
    AddQualificationDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
